import { render, staticRenderFns } from "./BatchInputLog.vue?vue&type=template&id=c87f30aa&scoped=true"
import script from "./BatchInputLog.vue?vue&type=script&lang=js"
export * from "./BatchInputLog.vue?vue&type=script&lang=js"
import style0 from "./BatchInputLog.vue?vue&type=style&index=0&id=c87f30aa&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87f30aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c87f30aa')) {
      api.createRecord('c87f30aa', component.options)
    } else {
      api.reload('c87f30aa', component.options)
    }
    module.hot.accept("./BatchInputLog.vue?vue&type=template&id=c87f30aa&scoped=true", function () {
      api.rerender('c87f30aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inputOutput/batchInputLog/BatchInputLog.vue"
export default component.exports